export const EXAMPLE = { revenue: 120000, cogs: 48000, overhead: 42000 };

export const PRESETS = [
  { key: "555", name: "5-5-5 Strategy", rev_up: 5, cogs_down: 5, ovh_down: 5 },
  { key: "bigger", name: "Go Bigger", rev_up: 10, cogs_down: 5, ovh_down: 5 },
  { key: "stretch", name: "Stretch", rev_up: 50, cogs_down: 5, ovh_down: 5 },
];

export const money = (n) => (n < 0 ? "-$" : "$") + Math.abs(Math.round(n)).toLocaleString();

export function presetFor({ rev_up, cogs_down, ovh_down }) {
  return PRESETS.find((p) => p.rev_up === rev_up && p.cogs_down === cogs_down && p.ovh_down === ovh_down);
}

export function scenarioLabel(s) {
  const moves = `+${s.rev_up}% sales, −${s.cogs_down}% COGS, −${s.ovh_down}% overhead`;
  const p = presetFor(s);
  return p ? `${p.name} (${moves})` : moves;
}

export function projectProfit(start, { rev_up, cogs_down, ovh_down }) {
  const cogsShare = start.revenue > 0 ? start.cogs / start.revenue : 0;
  const newRevenue = start.revenue * (1 + rev_up / 100);
  return newRevenue - newRevenue * cogsShare * (1 - cogs_down / 100) - start.overhead * (1 - ovh_down / 100);
}
